import { h, Component, Fragment, createRef } from "preact";
import PropTypes from "prop-types";
import {
  debounce,
  sendRequest,
  validateDate,
  validateEmail,
  validateFiles,
} from "../../tools";
import TextInput from "./TextInput";
import AddressSuggestion from "./address-form/AddressSuggestion";
import Modal from "./Modal";
import CameraButton from "./CameraButton";
import FileInputInnowave from "./FileInputInnowave";
import { NES_CLASSES } from "../constants/innowave";

const fileParams = {
  allowedFileTypes: [
    "jpg",
    "jpeg",
    "png",
    "pdf",
    "doc",
    "docx",
    "rtf",
    "xls",
    "xlsx",
    "zip",
    "sig",
    "xml ",
  ],
  maxSizeFile: 20971520,
  maxCountFile: 20,
};

export default class ServiceFormRenewalPersonalAccount extends Component {
  static propTypes = {
    urlCreate: PropTypes.string.isRequired,
    products: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    onSubmited: PropTypes.func,
    typeForm: PropTypes.string,
    privacyPolicyUrl: PropTypes.string.isRequired,
    userAgreementUrl: PropTypes.string.isRequired,
    apiDebtUrl: PropTypes.string.isRequired,
    apiContractInfoUrl: PropTypes.string.isRequired,
    apiLocationUrl: PropTypes.string.isRequired,
    urlGetHouseGuid: PropTypes.string.isRequired,
    serviceIds: PropTypes.object.isRequired,
    firstName: PropTypes.string,
    secondName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.phoneInputRef = createRef();
    this.dateDobRef = createRef();
    this.passportRef = createRef();
    this.dateEgrnRef = createRef();
    this.datePassportRef = createRef();
    this.state = {
      values: {
        fileEgrp: [],
        fileContractBuySell: [],
        contracts: [],
        checkedContracts: [],
        fetchingFlat: false,
      },
      modalCamera: false,
      modalFileInput: null,
      loading: false,
    };
    this.submitted = false;
    this.requiredFields = [
      "lastName",
      "firstName",
      "phoneNumber",
      "dob",
      "pob",
      "passport",
      "passportIssueBy",
      "city",
      "street",
      "house",
      // 'flat',
      "countOwners",
      "countResidents",
      "fileEgrp",
      "email",
      "checkedContracts",
      "datePassport",
      "dateEgrn",
    ];
    this.fieldsName = {
      lastName: "Фамилия",
      firstName: "Имя",
      dob: "День рождения",
      pob: "Место рождения",
      passport: "Серия/номер паспорта",
      city: "Населённый пункт",
      street: "Улица",
      house: "Дом",
      flat: "Квартира",
      meterReading:
        "Показания прибора учета на момент перехода права собственности",
      countResidents: "Количество проживающих",
      countOwners: "Количество владельцев",
      phoneNumber: "Номер телефона",
      email: "E-mail",
      products: "Услуга",
      fileEgrp: "Выписка ЕГРП или свидетельство права собственности",
      fileContractBuySell: "Скан договора купли продажи",
      checkedContracts: "Договор на переоформление",
      datePassport: "Дата выдачи паспорта",
      passportIssueBy: "Кем выдан паспорт",
      dateEgrn: "Дата выписки ЕГРН",
    };
    this.errorsApi = {};

    // modify file to be able to handle meta-info
    File.prototype.__loaded = false; // file has been uploaded to API
    File.prototype.__processed = false; // file has been processed
    File.prototype.__definitions = [];
  }

  clearForm = () => {
    this.submitted = false;
    this.errorsApi = {};
    $(this.phoneInputRef.current).val("");
    $(this.dateDobRef.current).val("");
    $(this.dateEgrnRef.current).val("");
    $(this.passportRef.current).val("");
    $(this.datePassportRef.current).val("");
    this.setState({
      values: {
        lastName: "",
        firstName: this.props.firstName,
        surname: this.props.secondName,
        dob: "",
        pob: "",
        passport: "",
        passportIssueBy: "",
        countOwners: "",
        countResidents: "",
        dateEgrn: "",
        fileEgrp: [],
        fileContractBuySell: [],

        phoneNumber: this.props.phone,
        email: this.props.email,
        agreeCompletedData: true,
        products: this.props.products,
        cityId: "",
        city: "",
        street: "",
        house: "",
        flat: "",
        meterReading: "",
        confirmPrivacyPolice: false,
        contracts: [],
        checkedContracts: [],
        datePassport: "",
        fetchingFlat: false,
      },
    });
    $(this.phoneInputRef.current).inputmask("setvalue", this.props.phone);
  };

  setMask(ref, mask, field) {
    const self = this;
    $(ref).inputmask({
      mask: mask,
      clearIncomplete: true,
      oncomplete: function (e) {
        self.setValues({ [field]: e.target.value });
      },
      onincomplete: function () {
        self.setValues({ [field]: "" });
      },
    });
  }

  componentDidMount() {
    const self = this;
    self.clearForm();
    this.setMask(
      this.phoneInputRef.current,
      "+7 (999) 999 9999",
      "phoneNumber"
    );
    this.setMask(this.dateDobRef.current, "99.99.9999", "dob");
    this.setMask(this.dateEgrnRef.current, "99.99.9999", "dateEgrn");
    this.setMask(this.datePassportRef.current, "99.99.9999", "datePassport");
    this.setMask(this.passportRef.current, "9999/999999", "passport");
  }

  render(props, state, context) {
    const errors = { ...this.errorsApi, ...this.validate() };

    const currentDebts = state.values.checkedContracts.reduce((acc, item) => {
      return acc + (parseFloat(item.debt) || 0);
    }, 0);

    console.debug("definitions:result", this.processDefinitions());

    return (
      <form className="form">
        <div className="form__body">
          <div className="form__title-2">{props.productName}</div>
          <div className="form__fieldset">
            <div className="form__fieldset-title">1. Данные собственника</div>
            <div className="form__item">
              <TextInput
                errors={errors.lastName}
                isRequired={this.isRequired("lastName")}
                name="Фамилия"
                inputProps={{
                  onChange: this.onChangeInput("lastName"),
                  value: state.values.lastName,
                  placeholder: "Введите фамилию",
                  id: "lastName",
                }}
              />
            </div>
            <div className="form__item">
              <TextInput
                errors={errors.firstName}
                isRequired={this.isRequired("firstName")}
                name="Имя"
                inputProps={{
                  onChange: this.onChangeInput("firstName"),
                  value: state.values.firstName,
                  placeholder: "Введите имя",
                  id: "firstName",
                }}
              />
            </div>
            <div className="form__item">
              <TextInput
                errors={errors.surname}
                isRequired={this.isRequired("surname")}
                name="Отчество (обязательно, если есть)"
                inputProps={{
                  onChange: this.onChangeInput("surname"),
                  value: state.values.surname,
                  placeholder: "Введите отчество",
                  id: "surname",
                }}
              />
            </div>
            <div className="form__item">
              <div
                className={`form-field form-field_gray ${
                  errors.dob ? "form-field_state_error" : ""
                }`}
              >
                <div className="form-field__inner">
                  <div className="form-field__title-row">
                    <label className="form-field__title">
                      {this.isRequired("dob")}Дата рождения
                    </label>
                  </div>
                  <div className="form-field__input-row">
                    <input
                      className="input form-field__input form-field__input_wd_sm hasDatepicker"
                      type="text"
                      placeholder="Введите дату"
                      autoComplete="off"
                      ref={this.dateDobRef}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="form__item">
              <TextInput
                errors={errors.pob}
                isRequired={this.isRequired("pob")}
                name="Место рождения"
                inputProps={{
                  onChange: this.onChangeInput("pob"),
                  value: state.values.pob,
                  placeholder: "Введите место",
                  id: "pob",
                }}
              />
            </div>
            <div className="form__item">
              <div
                className={`form-field form-field_gray ${
                  errors.passport ? "form-field_state_error" : ""
                }`}
              >
                <div className="form-field__inner">
                  <div className="form-field__title-row">
                    <label className="form-field__title">
                      {this.isRequired("passport")}Серия/номер паспорта
                    </label>
                  </div>
                  <div className="form-field__input-row">
                    <input
                      className="input form-field__input"
                      type="text"
                      placeholder="Введите серию номер"
                      autoComplete="off"
                      ref={this.passportRef}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form__item">
              <TextInput
                errors={errors.passportIssueBy}
                isRequired={this.isRequired("passportIssueBy")}
                name="Кем выдан паспорт"
                inputProps={{
                  onChange: this.onChangeInput("passportIssueBy"),
                  value: state.values.passportIssueBy,
                  placeholder: "Введите кем выдан паспорт",
                  id: "passportIssueBy",
                }}
              />
            </div>

            <div className="form__item">
              <div
                className={`form-field form-field_gray ${
                  errors.datePassport ? "form-field_state_error" : ""
                }`}
              >
                <div className="form-field__inner">
                  <div className="form-field__title-row">
                    <label className="form-field__title">
                      {this.isRequired("datePassport")}Дата выдачи паспорта
                    </label>
                  </div>
                  <div className="form-field__input-row">
                    <input
                      className="input form-field__input form-field__input_wd_sm hasDatepicker"
                      type="text"
                      placeholder="Введите дату"
                      autoComplete="off"
                      ref={this.datePassportRef}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="form__fieldset">
            <div className="form__fieldset-title">
              2. Данные жилого помещения
            </div>
            <AddressSuggestion
              title={`${this.isRequired(
                "city"
              )}Населенный пункт, улица (микрорайон, квартал, ДНП, иное), номер дома`}
              error={
                errors.city || errors.street || errors.house
                  ? "form-field_state_error"
                  : ""
              }
              apiUrl={props.apiLocationUrl}
              onSelect={this.onAddressSelect}
              defaultValue={""}
              defaultDisplayValue={""}
            />
            <div className="form__item">
              <TextInput
                errors={errors.flat}
                isRequired={this.isRequired("flat")}
                name="Квартира (Если у вас частный дом — поле оставляем пустым)"
                inputProps={{
                  onChange: this.onFlatSelect,
                  value: state.values.flat,
                  placeholder: "Укажите квартиру",
                  disabled:
                    !state.values.city ||
                    !state.values.street ||
                    !state.values.house,
                  id: "flat",
                }}
              />
            </div>
            <div className="form__item">
              <TextInput
                errors={errors.meterReading}
                isRequired={this.isRequired("meterReading")}
                name="Показания прибора учета на момент перехода права собственности"
                inputProps={{
                  onChange: this.onChangeInput("meterReading"),
                  value: state.values.meterReading,
                  placeholder: "Показания прибора учёта",
                  id: "meterReading",
                  type: "number",
                  className:
                    "input form-field__input input__without-appearance",
                }}
              />
            </div>
            {!!state.values.contracts.length && (
              <Fragment>
                <div className="form__item">
                  <div
                    className={`form-field form-field_gray ${
                      errors.checkedContracts ? "form-field_state_error" : ""
                    }`}
                  >
                    <div className="form-field__inner">
                      <div className="form-field__title-row">
                        <label className="form-field__title">
                          {this.isRequired("checkedContracts")}Договор на
                          переоформление
                        </label>
                      </div>
                      <div className="form-field__input-row">
                        {state.values.contracts.map((item) => {
                          const key =
                            "checkbox-contract_" + item.contractNumber;
                          return (
                            <div className="checkbox" key={key}>
                              <input
                                className="checkbox__input"
                                type="checkbox"
                                checked={
                                  state.values.checkedContracts.indexOf(
                                    item
                                  ) !== -1
                                }
                                onChange={this.onContractSelect(item)}
                                id={key}
                              />
                              <label className="checkbox__label" htmlFor={key}>
                                {item.contract + " " + item.fullName}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}

            <div className="form__item">
              <TextInput
                errors={errors.countResidents}
                isRequired={this.isRequired("countResidents")}
                name="Количество проживающих"
                inputProps={{
                  onChange: this.onChangeInput("countResidents"),
                  value: state.values.countResidents,
                  placeholder: "Введите количество проживающих",
                  id: "countResidents",
                }}
              />
            </div>
            <div className="form__item">
              <TextInput
                errors={errors.countOwners}
                isRequired={this.isRequired("countOwners")}
                name="Количество собственников"
                inputProps={{
                  onChange: this.onChangeInput("countOwners"),
                  value: state.values.countOwners,
                  placeholder: "Введите количество собственников",
                  id: "countOwners",
                }}
              />
            </div>
            <Fragment>
              <div className="form__item">
                <div
                  className={`form-field form-field_gray ${
                    errors.dateEgrn ? "form-field_state_error" : ""
                  }`}
                >
                  <div className="form-field__inner">
                    <div className="form-field__title-row">
                      <label className="form-field__title">
                        {this.isRequired("dateEgrn")}Дата выписки ЕГРН
                      </label>
                    </div>
                    <div className="form-field__input-row">
                      <input
                        className="input form-field__input form-field__input_wd_sm hasDatepicker"
                        type="text"
                        placeholder="Введите дату"
                        autoComplete="off"
                        ref={this.dateEgrnRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          </div>
          {typeof currentDebts !== "undefined" && (
            <div className="form__item form__item_horizontal form__item_vertical-center">
              <div className="form-info-block form-info-block_vertical">
                <div className="form-info-block__item">
                  <div className="form-info-block__name">
                    Сумма к оплате на текущую дату, без учета указанного выше
                    показания"
                  </div>
                  <div className="form-info-block__value">
                    {currentDebts.toLocaleString("ru-RU", {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 0,
                    })}{" "}
                    р
                  </div>
                </div>
              </div>
              <label className="checkbox">
                <input
                  className="checkbox__input"
                  type="checkbox"
                  checked={state.values.agreeCompletedData}
                  onClick={this.onChangeCheckbox("agreeCompletedData")}
                />
                <span className="checkbox__label">
                  согласен с заполненными данными
                </span>
              </label>
            </div>
          )}
          <div className="form__fieldset">
            <div className="form__fieldset-title">Контактные данные</div>
            <div className="form__item form__item_horizontal">
              <div
                className={`form-field form-field_gray ${
                  errors.phoneNumber ? "form-field_state_error" : ""
                }`}
              >
                <div className="form-field__inner">
                  <div className="form-field__title-row">
                    <label className="form-field__title" htmlFor="phoneNumber">
                      {this.isRequired("phoneNumber")}Номер телефона
                    </label>
                  </div>
                  <div className="form-field__input-row">
                    <input
                      className="input form-field__input"
                      type="text"
                      id="phoneNumber"
                      ref={this.phoneInputRef}
                    />
                  </div>
                </div>
              </div>
              <TextInput
                errors={errors.email}
                isRequired={this.isRequired("email")}
                name="Почта"
                inputProps={{
                  onChange: this.onChangeInput("email"),
                  value: state.values.email,
                  placeholder: "Введите почту",
                  id: "email",
                }}
              />
            </div>
          </div>

          <fieldset className="form__fieldset">
            <div className="form__item form__item_horizontal">
              {props.isTerminal ? (
                <CameraButton
                  openModal={this.openModal("fileEgrp")}
                  onDeleteFile={this.onDeleteFile}
                  field={"fileEgrp"}
                  values={this.state.values}
                  errors={errors}
                  getLabelField={() =>
                    "* Документ, подтверждающий право собственности (свидетельство о праве собственности, выписка из ЕГРН/ЕГРП (все страницы), или договор социального найма)"
                  }
                  horizontal={true}
                  fileParams={fileParams}
                />
              ) : (
                <FileInputInnowave
                  renderInput={true}
                  title={
                    <span className={"form__fieldset__description"}>
                      * Документ, подтверждающий право собственности (один или
                      несколько из нижеперечисленных) - все страницы:
                      <ul>
                        <li> - свидетельство о праве собственности;</li>
                        <li> - выписка из ЕГРН/ЕГРП;</li>
                        <li> - договор социального найма;</li>
                        <li> - договор о расторжении социального найма;</li>
                        <li> - договор купли-продажи;</li>
                        <li> - свидетельство о праве на наследство;</li>
                        <li> - акт приема-передачи жилого помещения;</li>
                        <li> - договор найма служебного помещения;</li>
                      </ul>
                    </span>
                  }
                  // title={'* Документ, подтверждающий право собственности (свидетельство о праве собственности, выписка из ЕГРН/ЕГРП (все страницы), или договор социального найма)'}
                  buttonNameNew="Вложить"
                  onChangeFile={this.onChangeFile}
                  onDeleteFile={this.onDeleteFile}
                  onFileLoaded={this.onFileLoaded}
                  onFileProcessed={this.onFileProcessed}
                  field={"fileEgrp"}
                  values={this.state.values}
                  errors={errors}
                />
              )}
            </div>
          </fieldset>
        </div>

        <div className="form__footer">
          <label className="checkbox form-block__footer-item">
            <input
              className="checkbox__input"
              type="checkbox"
              checked={this.state.values.confirmPrivacyPolice}
              onClick={this.onChangeCheckbox("confirmPrivacyPolice")}
            />
            <span className="checkbox__label checkbox__label_fz_sm checkbox__label_cl_text-3">
              Я даю{" "}
              <a href={props.userAgreementUrl} target="_blank">
                согласие на обработку моих персональных данных
              </a>{" "}
              АО «НовосибирскЭнергосбыт» в соответствии с{" "}
              <a href={props.privacyPolicyUrl} target="_blank">
                «Политикой обработки персональных данных»
              </a>
            </span>
          </label>
          {!!errors &&
            Object.values(errors).map((item) => {
              return <p className="form__error-text">{item}</p>;
            })}
          <button
            onClick={this.onSubmitForm}
            disabled={
              Object.keys(errors).length ||
              !this.state.values.confirmPrivacyPolice ||
              !this.state.values["fileEgrp"].length ||
              !this.state.values["fileEgrp"].every((item) => !!item.__processed)
            }
            className="button-primary button-primary_pdv_lg form__submit-btn"
          >
            {this.state.loading ? "Отправка заявки" : "Отправить заявку"}
          </button>
        </div>
        {props.isTerminal && state.modalCamera && (
          <Modal
            onClose={this.closeModal}
            onChange={this.onChangeCameraInput(this.state.modalFileInput)}
          />
        )}
      </form>
    );
  }

  closeModal = () => {
    this.setState({ modalCamera: false, modalFileInput: null });
  };

  openModal = (field) => (e) => {
    this.setState({ modalCamera: true, modalFileInput: field });
  };

  /**
   *
   * @returns {boolean}
   */
  processDefinitions = () => {
    const definitions = [...this.state.values["fileEgrp"]]
      .map((item) => item.__definitions)
      .flat();

    // console.debug(definitions);

    // process each group:
    for (let i = 0; i < NES_CLASSES.length; i++) {
      // find only required
      const required = NES_CLASSES[i].filter((item) => item.r);
      // if every required item in the definition array, we consider this a valid form
      if (required.every((item) => definitions.includes(item.t))) {
        return true;
      }
    }

    // nothing found
    return false;
  };

  validate = () => {
    let errors = {};
    const self = this;
    if (!this.submitted) return errors;

    const { values } = this.state;

    this.requiredFields.forEach((requiredField) => {
      if (
        typeof values[requiredField] === "undefined" ||
        values[requiredField] === null ||
        values[requiredField].length === 0
      ) {
        const fieldName =
          requiredField in self.fieldsName
            ? self.fieldsName[requiredField]
            : "";
        errors[requiredField] = `"${fieldName}" обязательно для заполнения`;
      }
    });

    if (values.dateEgrn.length && !validateDate(values.dateEgrn)) {
      errors.dateEgrn = "Дата выписки ЕГРН заполнена неверно";
    }

    if (values.dob.length && !validateDate(values.dob)) {
      errors.dob = "Дата рождения заполнена неверно";
    }

    if (values.datePassport.length && !validateDate(values.datePassport)) {
      errors.datePassport = "Дата выдачи паспорта заполнено неверно";
    }

    if (values.email && !validateEmail(values.email)) {
      errors.email = "E-mail заполнен неверно";
    }

    const { maxCountFile, maxSizeFile, allowedFileTypes } = fileParams;

    errors = {
      ...errors,
      ...validateFiles(
        values.fileEgrp,
        maxCountFile,
        maxSizeFile,
        allowedFileTypes
      ),
    };
    errors = {
      ...errors,
      ...validateFiles(
        values.fileContractBuySell,
        maxCountFile,
        maxSizeFile,
        allowedFileTypes
      ),
    };

    return errors;
  };

  isRequired = (fieldName) =>
    this.requiredFields.indexOf(fieldName) !== -1 ? "* " : "";

  onChangeCameraInput = (field) => (file, fileDataUrl) => {
    this.setValues({ [field]: [...this.state.values[field], file] });
  };

  onChangeFile = (field) => (e) => {
    this.setValues({
      [field]: [...this.state.values[field], ...e.target.files],
    });
  };

  onDeleteFile = (file, field) => (e) => {
    e.preventDefault();
    this.setValues({
      [field]: [...this.state.values[field].filter((item) => item !== file)],
    });
  };

  onFileLoaded = (file, field) => () => {
    const state = [...this.state.values[field]];
    const index = state.findIndex((item) => item === file);
    if (index > -1) {
      state[index]["__loaded"] = true;
      this.setValues({ [field]: [...state] });
    }
  };

  onFileProcessed = (file, field) => (definitions) => {
    const state = [...this.state.values[field]];
    const index = state.findIndex((item) => item === file);
    if (index > -1) {
      state[index]["__processed"] = true;
      state[index]["__definitions"] = definitions.map(
        (item) => item.definitionName
      );

      // this.setState({...this.state, foundDefinitions: [...this.state.foundDefinitions, ...definitions.map(item => item.definitionName)]}, () => {
      this.setValues({ [field]: [...state] });
      // });
    }
  };

  onChangeInput = (field) => (e) => {
    this.setValues({ [field]: e.target.value });
  };

  onChangeCheckbox = (field) => (e) => {
    this.setValues({ [field]: !this.state.values[field] });
  };

  onAddressSelect = (city, street, house) => {
    this.setValues({
      city,
      street,
      house,
      flat: "",
      contracts: [],
      checkedContracts: [],
    });
    this.removeErrorsApi({ city, street, home: house });
    this.fetchContracts(city, street, house, 0);
  };

  fetchContracts = (city, street, house, flat) => {
    const self = this;

    const formData = new FormData();
    formData.append("city", city);
    formData.append("street", street);
    formData.append("home", house);
    formData.append("flat", flat);

    debounce(() => {
      self.setValues({ fetchingFlat: true });
      return sendRequest(self.props.apiContractInfoUrl, {
        body: formData,
        type: "POST",
        showLoader: true,
      }).then((data) => {
        if (data.status === 200) {
          self.setValues({
            contracts: data.data,
            checkedContracts: [],
            fetchingFlat: false,
          });
        }
        if (data.status === 422) {
          JSON.parse(data.data).map((item) => {
            self.setValues({
              contracts: [],
              checkedContracts: [],
              fetchingFlat: false,
            });
            self.errorsApi[item["field"]] = item.message;
          });
        }
        if (data.status >= 500 || data.status === 0) {
          $.disMsg(
            "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
            { type: "false" }
          );
          self.setValues({ fetchingFlat: false });
        }
      });
    }, 500)();
  };

  onFlatSelect = (e) => {
    if (!this.state.values.fetchingFlat) {
      const flat = e.target.value;
      const { city, street, house } = this.state.values;
      this.setValues({ flat });
      this.fetchContracts(city, street, house, flat);
    } else {
      const { flat } = this.state.values;
      this.setValues({ flat });
    }
  };
  onContractSelect = (item) => (e) => {
    let checkedContracts = this.state.values.checkedContracts;
    if (checkedContracts.indexOf(item) !== -1) {
      checkedContracts = checkedContracts.filter((elem) => elem !== item);
    } else {
      checkedContracts = [...checkedContracts, item];
    }

    this.setValues({ checkedContracts });
  };

  setValues = (values) => {
    this.removeErrorsApi(values);
    this.setState((state, props) => ({
      values: {
        ...state.values,
        ...values,
      },
    }));
  };

  removeErrorsApi = (fields) => {
    const self = this;
    Object.keys(fields).map((field) => {
      if (field in self.errorsApi) {
        delete self.errorsApi[field];
      }
    });
  };

  onSubmitForm = (e) => {
    e.preventDefault();
    const self = this;
    this.submitted = true;
    const errors = this.validate();
    if (Object.keys(errors).length) {
      this.forceUpdate();
      return;
    }

    this.setState({ loading: true });
    const formData = new FormData();
    const { values } = this.state;
    const props = self.props;

    formData.append("typeForm", props.typeForm);
    formData.append("lastName", values.lastName);
    formData.append("firstName", values.firstName);
    formData.append("surname", values.surname);
    formData.append("dob", values.dob);
    formData.append("pob", values.pob);
    formData.append("passport", values.passport);
    formData.append("countOwners", values.countOwners);
    formData.append("countResidents", values.countResidents);
    formData.append("dateEgrn", values.dateEgrn);
    formData.append("agreeCompletedData", values.agreeCompletedData ? 1 : 0);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("email", values.email);
    formData.append("products", values.products);
    formData.append("city", values.city);
    formData.append("street", values.street);
    formData.append("house", values.house);
    formData.append("flat", values.flat.length === 0 ? 0 : values.flat);
    formData.append("meterReading", values.meterReading);
    formData.append("datePassport", values.datePassport);
    formData.append("passportIssueBy", values.passportIssueBy);

    formData.append(
      "serviceId",
      values.agreeCompletedData
        ? props.serviceIds.agree
        : props.serviceIds.disagree
    );

    values.checkedContracts.map((item, key) => {
      formData.append("contracts[" + key + "][fullName]", item.fullName);
      formData.append("contracts[" + key + "][contract]", item.contract);
      formData.append(
        "contracts[" + key + "][contractNumber]",
        item.contractNumber
      );
      formData.append("contracts[" + key + "][addressId]", item.addressId);
      formData.append("contracts[" + key + "][debt]", item.debt);
      formData.append("contracts[" + key + "][bspid]", item.bspid);
    });

    if (values.fileEgrp.length) {
      values.fileEgrp.forEach((item) => {
        formData.append("fileEgrp[]", item);
      });
    }
    if (values.fileContractBuySell.length) {
      values.fileContractBuySell.forEach((item) => {
        formData.append("fileContractBuySell[]", item);
      });
    }

    if (
      (!values.fileEgrp.length || !this.processDefinitions()) &&
      !this.state.sendAnyway
    ) {
      window.sendAnyway = () =>
        this.setState({ ...this.state, sendAnyway: true }, () =>
          this.onSubmitForm(e)
        );
      if (typeof this.props.onFileProblemsFound === "function") {
        return this.props.onFileProblemsFound();
      } else {
        console.warn("onFileProblemsFound function not found");
      }
    }

    sendRequest(props.urlCreate, {
      body: formData,
      type: "POST",
      headers: { contentType: false, processData: false },
      showLoader: true,
    }).then((data) => {
      self.setState({ loading: false });
      if (data.status === 200) {
        this.clearForm();
        let numbers = data.data.appeal.map((item) => {
          return (
            "<div><a href=https://www.nskes.ru/?numberAppeal='" +
            item.number +
            "' target='_blank'>" +
            item.number +
            "</a></b></div>"
          );
        });
        if (numbers.length > 1) {
          numbers = "<div>Номера Ваших обращений:</div>" + numbers.join("");
        } else {
          numbers = "<div>Номер Вашего обращения:</div>" + numbers.join("");
        }

        props.onSubmited(numbers);
      }
      if (data.status === 422) {
        JSON.parse(data.data).map((item) => {
          self.errorsApi[item["field"]] = item.message;
        });
      }
      if (data.status >= 500 || data.status === 0) {
        $.disMsg(
          "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
          { type: "false" }
        );
        return;
      }
    });
  };
}
